import React, { useState } from 'react';
interface AuditType {
  index: number;
  result: any;
  handleHitSelect?: any;
  handleVisClick: any;
  handleWhitelistClick: (result: any) => void;
  isWhitelisted?: boolean;
}

const ResultsRow: React.FC<AuditType> = ({
  index,
  result,
  handleHitSelect,
  handleWhitelistClick,
  isWhitelisted,
}) => {
  const [ isMenuOpen, setIsMenuOpen ] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return (
    <>
      <div className='view-history-body-frame-row'>
        <div
          className='view-history-body-frame-row-name'
          onClick={() => handleHitSelect(result, index)}
        >
          <div className='view-history-body-frame-row-date-text-names'>
            {result.field}
          </div>
        </div>
        <div className='view-history-body-frame-row-dates'>
          <div className='view-history-body-frame-row-date-text'>
            {result.hits}
          </div>
        </div>
        <div className='view-history-body-frame-row-dates'>
          <div className='view-history-body-frame-row-date-texts'>
            <div>0</div>
          </div>
        </div>
        <div
          className='view-history-body-frame-row-icon-dots'
          style={{ position: 'relative' }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {isWhitelisted && (
              <div className={'whitelisted_badge'}>Whitelisted</div>
            )}
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 18 18'
              fill='none'
              cursor={'pointer'}
              onClick={toggleMenu}
            >
              <circle cx='9' cy='4.5' r='1.5' fill='var(--text-primary)' />
              <circle cx='9' cy='9' r='1.5' fill='var(--text-primary)' />
              <circle cx='9' cy='13.5' r='1.5' fill='var(--text-primary)' />
            </svg>
          </div>
          {isMenuOpen && (
            <div className={'whitelist-popup-menu'}>
              <div
                className={'whitelist-popup-menu-item'}
                onClick={() => {
                  handleWhitelistClick(result);
                  setIsMenuOpen(false);
                }}
              >
                {isWhitelisted ? 'Remove from whitelist' : 'Whitelist'}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ResultsRow;
